import { render, staticRenderFns } from "./Filepicker.vue?vue&type=template&id=12a95dea&"
import script from "./Filepicker.vue?vue&type=script&lang=js&"
export * from "./Filepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports